import { FieldType } from '@ngx-formly/material';

import { Component, OnInit } from '@angular/core';

import { SnGoogleGeocoderResult } from '@lib/geo/google/geocoder';

import { ISnPlacesAutocompleteFormFieldConfig } from '../../interfaces/places-autocomplete-form-field-config.interface';

@Component({
  selector: 'sn-places-autocomplete-form-field',
  templateUrl: './places-autocomplete.form-field.html',
  styleUrls: ['./places-autocomplete.form-field.scss'],
})
export class SnPlacesAutocompleteFormField extends FieldType implements OnInit {
  public defaultOptions: ISnPlacesAutocompleteFormFieldConfig = {
    type: 'places-autocomplete',
    templateOptions: {
      appearance: 'fill',
      autocompleteOn: true,
    },
  };

  constructor() {
    super();
  }

  public ngOnInit(): void {}

  public onPlaceChange(place: SnGoogleGeocoderResult): void {
    if (this.to.change) {
      this.to.change(this.field, place);
    }
  }
}
